import ConfirmDialog from "components/ConfirmDialog";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import {
  AdminUnlinkFacultyPortalUserRequest,
  ResourceV2,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";

type UnlinkFacultyPortalUserDialogProps = {
  resource?: ResourceV2;
  onSuccess: () => void;
  onClose: () => void;
};

export default function UnlinkFacultyPortalUserDialog({
  resource,
  onSuccess,
  onClose,
}: UnlinkFacultyPortalUserDialogProps) {
  const { formatMessage: t } = useIntl();
  const { resourceService } = useGlobalContext();

  const unlinkFacultyPortalUser = async () => {
    try {
      await resourceService.unlinkFacultyPortalUser(
        AdminUnlinkFacultyPortalUserRequest.fromJS({
          resourceId: resource?.id,
          organizationId: resource?.organizationId,
        })
      );

      onSuccess();
    } catch (error) {
      return { [FORM_ERROR]: translateError(error, t) };
    }
  };

  return (
    <ConfirmDialog
      dialogTitleKey="unlinkFacultyAndUser"
      contentKey="areYouSureToUnlinkFaculty"
      open={!!resource}
      onCancel={onClose}
      handleConfirm={unlinkFacultyPortalUser}
      confirmLabel="confirmButton"
    />
  );
}
